"use strict";

exports.__esModule = true;
exports.DeviceDetailsURLFilter = void 0;
var _react = _interopRequireWildcard(require("react"));
var _URLFilter = require("../../Core/URLFilter");
var _Time = require("../../Time");
var _timeDefinitions = require("../../timeDefinitions");
var _dec, _class, _DeviceDetailsURLFilter;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * URL filter for deviceDetails.
 */
var DeviceDetailsURLFilter = exports.DeviceDetailsURLFilter = (_dec = _Time.TimeContext.withContext, _dec(_class = (_DeviceDetailsURLFilter = /*#__PURE__*/function (_Component) {
  function DeviceDetailsURLFilter() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceDetailsURLFilter, _Component);
  var _proto = DeviceDetailsURLFilter.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      time = _this$props.time,
      timeRangeKind = _this$props.timeRangeKind;
    var start;
    var end = new Date(time.currentWorkday.interval.endMillis).toISOString();
    if (timeRangeKind === "multiDay") {
      start = new Date(time.currentWorkday.interval.startMillis - _timeDefinitions.WEEK_IN_MILLIS).toISOString();
    } else {
      start = new Date(time.currentWorkday.interval.startMillis).toISOString();
    }
    return /*#__PURE__*/_react["default"].createElement(_URLFilter.URLFilterController, {
      replace: true,
      params: {
        period: {
          "default": start + "/" + end
        },
        device: {
          multiple: false,
          "default": undefined
        }
      }
    }, this.props.children);
  };
  return DeviceDetailsURLFilter;
}(_react.Component), _DeviceDetailsURLFilter.defaultProps = {
  time: undefined
}, _DeviceDetailsURLFilter)) || _class);